/** Shared by the visible camera and recording compositor. */
export const CAMERA_OPACITY = .58
